import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

export const NavListItemText = styled(ListItemText)`
  color: white;
  font-size: 14px;
`;
